<div class="account-dialog">
    <ng-template datasource-directive></ng-template>
</div>
